import React, { useState, useEffect, useRef } from 'react';
import { Html5Qrcode, Html5QrcodeSupportedFormats } from 'html5-qrcode';
import { useNavigate } from 'react-router-dom';

function BarcodeDetails() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    flightNo: 'LH0014',
    sqNo: '019',
    timeStamp: '11:43:21',
    airline: 'LH',
  });
  const [scannedData, setScannedData] = useState('');
  const html5QrcodeScannerRef = useRef(null);

  useEffect(() => {
    const config = {
      fps: 10,
      qrbox: { width: 400, height: 200 },
      facingMode: "environment",
      formatsToSupport: [
        Html5QrcodeSupportedFormats.CODE_128,
        Html5QrcodeSupportedFormats.CODE_39,
        Html5QrcodeSupportedFormats.EAN_13,
        Html5QrcodeSupportedFormats.EAN_8,
        Html5QrcodeSupportedFormats.UPC_A,
        Html5QrcodeSupportedFormats.UPC_E,
        Html5QrcodeSupportedFormats.ITF,
        Html5QrcodeSupportedFormats.CODABAR,
        Html5QrcodeSupportedFormats.QR_CODE
      ]
    };

    html5QrcodeScannerRef.current = new Html5Qrcode("reader");
    let isScanning = false;

    html5QrcodeScannerRef.current.start(
      { facingMode: "environment" },
      config,
      (decodedText, decodedResult) => {
        setScannedData(decodedText);
        // Optionally, update formData based on scanned barcode here
      },
      (errorMessage) => {
        // suppress frequent "no match" errors to reduce console noise
      }
    ).then(() => {
      isScanning = true;
    }).catch(err => {
      console.error('Unable to start scanning:', err);
    });

    return () => {
      if (html5QrcodeScannerRef.current && isScanning) {
        html5QrcodeScannerRef.current.stop().then(() => {
          html5QrcodeScannerRef.current.clear();
          html5QrcodeScannerRef.current = null;
        }).catch(err => {
          console.error('Failed to stop scanning:', err);
        });
      } else {
        html5QrcodeScannerRef.current = null;
      }
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = () => {
    // alert('Submitted: ' + JSON.stringify(formData));
    navigate('/welcome');
  };

  return (
    <div style={{
      maxWidth: 400,
      margin: 'auto',
      padding: 20,
      backgroundColor: '#f0f0f5',
      borderRadius: 10,
      fontFamily: "'Arial Black', Arial, sans-serif",
      color: '#000',
      textAlign: 'center',
      boxShadow: '0 0 10px rgba(0,0,0,0.1)'
    }}>
      {/* ARL Aviation Services logo */}
      <img
        src="/arl-logo.png"
        alt="ARL Aviation Services Logo"
        style={{ width: '100%', maxWidth: 250, marginBottom: 20, display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
      />

      {/* Barcode scanner section */}
      <div style={{ border: '3px solid yellow', borderRadius: 8, marginBottom: 20, padding: 10, width: 400, height: 200, marginLeft: 'auto', marginRight: 'auto', overflow: 'hidden', position: 'relative' }}>
        <div id="reader" style={{ width: '100%', height: 200, position: 'relative' }} />
      </div>
      <style>{`
        #reader video {
          position: absolute !important;
          top: 0 !important;
          left: 0 !important;
          width: 100% !important;
          height: 100% !important;
          object-fit: contain !important;
          border-radius: 8px !important;
          z-index: 1 !important;
        }
        #reader > *:not(video) {
          display: none !important;
        }
      `}</style>

      {/* Display scanned data */}
      {scannedData && (
        <p style={{ fontWeight: 'bold', marginBottom: 20, color: 'red' }}>Scanned Barcode: {scannedData}</p>
      )}

      <div style={{ textAlign: 'left', fontWeight: 'bold', fontSize: 16, marginBottom: 20 }}>
        {[
          { label: 'FLIGHT NO.', name: 'flightNo', value: formData.flightNo },
          { label: 'SQ NO.', name: 'sqNo', value: formData.sqNo },
          { label: 'TIME STAMP', name: 'timeStamp', value: formData.timeStamp },
          { label: 'AIRLINE', name: 'airline', value: formData.airline },
        ].map(({ label, name, value }) => (
          <div key={name} style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
            <label style={{ flexBasis: '40%', fontWeight: 'bold' }}>{label}</label>
            <input
              type="text"
              name={name}
              value={value}
              onChange={handleChange}
              style={{
                flexGrow: 1,
                padding: 5,
                fontWeight: 'normal',
                fontSize: 16,
                borderRadius: 4,
                border: '1px solid #ccc'
              }}
            />
          </div>
        ))}
      </div>

      <button
        onClick={handleSubmit}
        style={{
          backgroundColor: '#2e7d32',
          color: 'white',
          fontWeight: 'bold',
          fontSize: 24,
          padding: '15px 0',
          width: '100%',
          border: 'none',
          borderRadius: 6,
          cursor: 'pointer',
          boxShadow: '0 4px 6px rgba(0,0,0,0.2)'
        }}
      >
        SUBMIT
      </button>
    </div>
  );
}

export default BarcodeDetails;
